export class BlockingError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'Blocking Error';
    Error.captureStackTrace(this, this.constructor);
  }
}
